<script setup lang="ts">
// The quota upsell (contract 16 §12) — v3's `layoutStore.activeDataExportModal()`, which opened a
// shell-global `ExportLimitModal` mounted in `DefaultLayout.vue:30`. v4 has no shell-global upsell
// slot, so the modal is feature-local and opened by the wizard host directly.
//
// It is the surface for BOTH quota signals, which is why `CreateExportJobFlow` collapses them into
// one `limitReached` outcome: the pre-flight `remaining === 0` guard (`DataExportCreate.vue:506-512`)
// and the server's create `403` (`:666-668`). Legacy rendered the 403 as a swal ERROR toast in one
// branch and this modal in the other; a depleted quota is never an error toast here.
import { useRouter } from 'vue-router'

import { useI18n } from '@/shared/i18n'
import { Button, Modal } from '@/shared/ui'

const open = defineModel<boolean>({ default: false })
const { t } = useI18n()
const router = useRouter()

/** The literal route NAME is deliberate: importing 11's barrel for it re-chunks this feature. */
function comparePlans(): void {
  open.value = false
  void router.push({ name: 'ComparePlans' })
}
</script>

<template>
  <Modal v-model="open" :title="t('dataExport.wizard.limit.title')" size="sm">
    <p class="export-limit__body m-0 text-muted">
      {{ t('dataExport.wizard.limit.body') }}
    </p>
    <template #footer>
      <Button variant="outline" @click="open = false">
        {{ t('dataExport.wizard.limit.dismiss') }}
      </Button>
      <Button @click="comparePlans">{{ t('dataExport.wizard.limit.comparePlans') }}</Button>
    </template>
  </Modal>
</template>
